module.exports = {
  HEADER_TRANSITION_Y: 1,
  SHORT_DESCRIPTION_LENGTH: 380,
  SHORTER_DESCRIPTION_LENGTH: 250,
};
